import {AssetsRequestParams} from "../../../infrastructure/models/params/assets-request-params";

export class CompetitionsSliderTopLogoParams extends AssetsRequestParams {
  constructor() {
    super();

    this.resourceName = this.resourceName + '/SLIDER_TOP_GAMES';
  }
}
